import { render, staticRenderFns } from "./TraxAccountUserEditPassword.vue?vue&type=template&id=cbc22d38"
import script from "./TraxAccountUserEditPassword.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserEditPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports